<div class="card-header d-flex justify-content-between">
    <h2>{{ title }}</h2>

    <a *ngIf="hasWriteAccess && onDashboard" [attr.aria-label]="'Create an invoice'" [routerLink]="['/app/charges/new']" class="btn btn-primary">
        <img class="plus-img" src="/assets/images/payhoa/other/plus_white.svg">Create an Invoice
    </a>

    <ng-container *ngIf="!onDashboard">
        <div class="d-xl-none">
            <button [matMenuTriggerFor]="invoiceActions"
                    class="btn btn-outline-secondary">
                Actions <i class="fa fa-chevron-down"></i>
            </button>

            <mat-menu #invoiceActions="matMenu">
                <a *ngIf="!collectionGraphLoading && hasWriteAccess" [attr.aria-label]="'Create an invoice'" [routerLink]="['/app/charges/new']" mat-menu-item>
                    Create an Invoice
                </a>

                <a *ngIf="!collectionGraphLoading && permissions['communication'].write && !onDashboard"
                   [routerLink]="['/app/communications/send-statements']"
                   mat-menu-item>
                    Resend Email Invoices
                </a>

                <a *ngIf="!collectionGraphLoading && permissions['communication'].write && !onDashboard"
                   [routerLink]="['/app/mail/send/invoice']"
                   mat-menu-item>
                    Mail Invoices
                </a>
            </mat-menu>
        </div>

        <div class="d-none d-xl-flex">
            <a *ngIf="!collectionGraphLoading && permissions['communication'].write && !onDashboard"
               [routerLink]="['/app/communications/send-statements']"
               class="btn btn-outline-secondary">
                <i class="fa fa-envelope-o"></i>
                Resend Email Invoices
            </a>

            <a *ngIf="!collectionGraphLoading && permissions['communication'].write && !onDashboard"
               [routerLink]="['/app/mail/send/invoice']"
               class="btn btn-outline-secondary">
                <i class="fa fa-envelope"></i>
                Mail Invoices
            </a>

            <a *ngIf="!collectionGraphLoading && hasWriteAccess" [attr.aria-label]="'Create an invoice'" [routerLink]="['/app/charges/new']" class="btn btn-primary d-flex align-items-center">
                <img class="plus-img" src="/assets/images/payhoa/other/plus_white.svg">Create an Invoice
            </a>
        </div>
    </ng-container>
</div>
<div class="card-body d-flex flex-column pt-2">

    <!-- loading -->
    <div *ngIf="collectionGraphLoading" class="d-loading">
        <div class="loader">Loading...</div>
    </div>

    <!-- shows if no values -->
    <div *ngIf="!collectionGraphLoading && !hasData">
        <p class="p-5 text-center">No invoices yet.</p>
    </div>


    <ng-container *ngIf="!collectionGraphLoading && hasData">
        <!-- invoices graph changers -->
        <div class="legends d-flex justify-content-between m-0">
            <div class="align-items-center">
                <div class="legend invoiced mb-1">
                    <span class="legend-word">Invoiced:</span>
                    <span class="legend-amt">
                        {{ legendInvoiceTotal | legfiCurrency:'USD':'symbol':'.2' }}
                    </span>
                </div>


                <div class="legend collected">
                    <span class="legend-word">Collected:</span>
                    <span class="legend-amt">
                        {{ legendCollectedTotal | legfiCurrency:'USD':'symbol':'.2' }}
                    </span>
                </div>
            </div>
            <div *ngIf="drilldown === null && showRangePicker" class="mr-0 justify-content-end align-items-center mat-select-width-auto">
                <mat-form-field class="single-select btn btn-outline-secondary">
                    <mat-select (selectionChange)="updateGraphDisplayType($event.value)"
                                [(ngModel)]="showCalendarYear"
                                panelClass="single-select-panel mat-menu-panel mat-elevation-z4">
                        <mat-option [value]="0">{{ 'Fiscal Year' }}</mat-option>
                        <mat-option [value]="1">{{ 'Calendar Year' }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="single-select btn btn-outline-secondary ">
                    <mat-select (selectionChange)="updateGraphYear($event.value)"
                                [(ngModel)]="graphYear"
                                panelClass="single-select-panel mat-menu-panel mat-elevation-z4">
                        <mat-option *ngFor="let year of yearFilters"
                                    [value]="year">{{ year }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="drilldown !== null" class="mr-0 justify-content-end align-items-center">
                <button class="btn btn-outline-secondary" (click)="resetChartData()">Back to 12 Month Overview</button>
            </div>

        </div>

        <div class="flex-grow-1">
            <canvas baseChart [options]="chartOptions" [data]="chartData" [type]="'bar'"></canvas>
        </div>
    </ng-container>

</div>
